<template>
  <div class="outerDiv" :style="configStyle">
        <header v-if="showHeader">
            <div class="filterVar">
                <div class="horizFlex">
                    <img alt="school logo" :src="schoolLogoFilePath"  class="logo" />
                    <label class="titleText headertext">Identity Administration</label>
                </div>
                
                <div class="vertFlex rightjustified" v-if="loggedIn">
                    <label class="textmedium headertext">{{loggedInUser.Name}}</label>
                    <linkbutton toplabel="Logout" @click="loggedIn=false" class="textmedium headertext"/>
                </div>
            </div>
        </header>
        
        <loginuser @loggedin='ready()' ref="login" v-if="!loggedIn"/>
        <div v-if="loggedIn">
            <badgeadmin/>     
        </div>

  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import style from '../style.js'
import datamethods from '../datamethods'
import loginuser from './login/loginuser.vue'
import badgeadmin from './actions/badgeadmin.vue'
import linkbutton from './controls/linkbutton.vue'
import axios from "axios";
import tutorial from '../components/controls/tutorial.vue'
import tutorialhelper from '../services/tutorialhelper.js'
export default {
    components:{
        loginuser,
        badgeadmin,
        linkbutton,
        tutorial
    },
    mixins:[style, datamethods,tutorialhelper],
    computed:{

        ...mapFields([
            'loggedIn',
            'loggedInUser',
            'currentNav',
            'badgeData',
            'logoOverride',
            'configOverride',
            'oldpassword',
            'username',
            'showHeader',
            'showHeaderFromURL',
            'token'
        ]),
        schoolLogoFilePath(){
            if(this.logoOverride!=''){
                return  this.imageBasePath + this.logoOverride
            }else{
                return './../' + window.SCHOOL_LOGO
            }
            
        },
        LogoFilePath(){
            if(this.logoOverride!=''){
                return  this.imageBasePath + this.logoOverride
            }else{
                return require('@/assets/MC_ID_Capture.png')
            }

        },
        
    },
    data(){
        return{
   

            //url
            BadgeGlobalKey:'',
            EmailAddress:'',
            LocationGlobalKey:'',
            PersonGlobalKey:'',


            //config
            institutionGlobalKey:window.INSTITUTION_KEY,
            
            
            frontLinkText:window.FRONT_LINK_TEXT,
            backLinkText:window.BACK_LINK_TEXT,

            ecommerceURL:window.URL_ECOMMERCE,
            validationURL:window.URL_VALIDATION,
            mobileidURL:window.URL_MOBILEID,

            //flags
            
            imageBasePath:'',

            message:'',
            showingValidator:false,

            //data
            
        }
    },
    methods:{

        async getImageBasePath(){
            //call api
            var response = await this.callAPI(null,'imagepath')
            //handle response
            if(response.Successful){
                this.imageBasePath =  response.StringResponse
            }else{
                this.message = response.Message
            }
        },
        imagePath(imagePath){
            return this.imageBasePath + imagePath;
        },

        ready(){
            this.currentNav="new"
            
        },

        autoClear(){
            this.message = ''
        },
        receiveMessage(event){
            try{
                var msg =  JSON.parse(event.data)
            }
            catch(err){
                return
            }
            
            var action = msg.action
            if(action !=undefined){
            
               // console.log("PA Receive Msg: " + action)
                switch (action) {
                    case 'refresh':
                        break;
                    case 'appupdate':
                        location.reload(true);
                    case 'tutorialstart':
                        this.tutorialStart()
                        break;
                    case 'tutorialend':
                        this.tutorialEnd();
                        break;
                    default:
                        break;
                }
                
            }
        },
        getIpAddress(){
      
            axios.get('https://api.ipify.org/?format=text')
            .then(response=>{
                    
                this.AddIPToAPI(response.data)
            })
                .catch(e=>{
                
                    console.log(e)
                    
                });
            //return response.data
            },
    },
    created(){
        const timer = setInterval(()=>{
            this.autoClear();
            },10000);
        
        this.$once("hook:beforeDestroy",()=>{
        clearInterval(timer);
        });
    },
    mounted(){
        //to receive msgs
        window.addEventListener('message', this.receiveMessage)

        var goAhead = true;
        let urlParams = new URLSearchParams(window.location.search)
        let tmp = urlParams.get('BadgeGlobalKey')
        if(tmp!=null){ this.BadgeGlobalKey = tmp;}

        tmp = urlParams.get('LocationGlobalKey')
        if(tmp!=null){ this.LocationGlobalKey = tmp;}

        tmp = urlParams.get('PersonGlobalKey')
        if(tmp!=null){ this.PersonGlobalKey = tmp;}

        tmp = urlParams.get('EmailAddress')
        if(tmp!=null){ this.EmailAddress = tmp;}
        
        tmp = urlParams.get('email')
        if(tmp!=null){this.username = tmp; }

        tmp = urlParams.get('header')
        if(tmp!=null){
            this.showHeader=tmp=='true';
            this.showHeaderFromURL=tmp=='true';
        }

        tmp = urlParams.get('temp')
        if(tmp!=null){
          
            console.log('in ch pass ')
            this.oldpassword = tmp;
            goAhead=false
            this.$nextTick(()=>{
            //this.changepass()
            this.$refs.login.changepassword();
            
            });
          
        }

        tmp = urlParams.get('logo')
        if(tmp!=null){ this.logoOverride = tmp;}

        tmp = urlParams.get('config')
        if(tmp!=null){this.configOverride=tmp }

        

        window.onbeforeunload= function(event){
            event.preventDefault()
        }
        this.setColors();
        this.getImageBasePath();
        
        
        //this.getBadgeDetail()
        //determine if token sent over (SSO)
        tmp = urlParams.get('token')
        if(tmp!=null){
            console.log('sso!')
            this.token=tmp
            this.$refs.login.post_login(tmp)
         }else{
            this.$refs.login.prelogin()
         }

         //add ip to api
         this.getIpAddress()

         //saml token
        tmp = urlParams.get('samltoken')
        if(tmp!=null){ 
            this.token = tmp;
            console.log('samltoken')
            
            this.$refs.login.post_login(tmp)
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/stylebase.scss";

body{
  height:100vh; 
  height: -webkit-fill-available;
  width:100vw;
  padding:0px;
  margin:0px;
  font-size:x-large;
  color:var(--text-color);
  background-color:var(--background-color);
}
.outerDiv{
  margin:0px;
  padding:0px;
  height:100vh;
}
.frontDiv{
    height:100vh;
    display:grid;
    grid-template-columns:auto;
    grid-template-rows:12% 15% 36% 10% 15% 12%;
}
.backDiv{
    height:100vh;
    display:grid;
    grid-template-columns:auto;
    grid-template-rows:12% 15% 46% 15% 12%;
}

.titleText{
    font-weight: bold;
    margin-left:10px;
}

/* HEADER */
header{
    background-color:var(--header-color);
    padding:10px;
}
.logo{
    height:60px;
}
.logo2{
    height:100px;
    margin:20px;
}


/* ALERT */
.alert{
    padding:10px;
}
.alertdiv{
    background-color: var(--alert-color);
    padding:10px;
}
.alerttext{
    color:var(--light-text-color);
    font-weight: bold;
}

/* STUDENT */
.studentimage{
    height:160px;
    margin:5px;
}
.studentinfo{
    width:100%;
    text-align: center;
}
.studentname{
    font-size:xx-large;
    font-weight:bolder;
    margin:5px 5px 5px 0px;
}

.studentclass{
    margin:10px;
}

/* STATUS */
.status{
    padding:20px;
}
.statustext{
    font-weight: bold;
    color:var(--alert-color);
}

/* BARCODE */
.barcode{
    padding:5px;
}

/* TOGGLE */
.toggle{
    background-color:var(--highlight-button-color);
    padding:10px;
}


/* INFO */
.info{
    text-align: left;
    padding:20px;
}
.infoset{
    display:flex;
    flex-direction: column;
    margin-bottom:25px;
}
.infobig{
    font-size:large;
    font-weight:bold;
}
.infolink{
    font-size:medium;
    text-decoration: underline;
}

.demobutton{
    color:white;
    background-color:rgb(24, 24, 207);
    border: none;
    border-radius:10px;
    width:215px;
    height:50px;
    padding:0px;
    font-size: medium;
    margin: 0px 10px 0px 10px;
  text-decoration: none;
  white-space: pre;
}
.buttondiv{
    display:flex;
    flex-direction: row;
    justify-content: center;
}
.textmedium{
    font-size: medium;

}
.headertext{
    color:var(--header-text-color);
}
</style>



            